import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Scenarios from '../components/Scenarios'

export default () => (
  <header className="App-header">
    <Row>
      <Col className="pageTitle">
        <h1>404</h1>
        <p className="slogan">Oops, that shouldn't have happened. The page you were looking for couldn't be found.</p>
        <br/>
        <br/>
        <br/>
      </Col>
    </Row>
    <Row>
      <Col>
        <h3 className="exploreScenarios">Explore the scenarios</h3>
      </Col>
    </Row>
    <Scenarios />
  </header>
);



// WEBPACK FOOTER //
// ./src/pages/404.js